import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/cluster/');


export async function getAvailableClusters() {
    const { result } = await doRequest('available/directly', {
        limit: 99999,
        query: '',
    });
    return result;
}

export async function loadCluster(id) {
    const { result } = await doRequest('load', { id });
    return result;
}

export async function updateContacts(reqt) {
    await doRequest('update/contacts', reqt, { blocking: true });
}

export async function updateDocuments(reqt) {
    await doRequest('update/documents', reqt, { blocking: true });
}

export async function updateLinks(reqt) {
    await doRequest('update/links', reqt, { blocking: true });
}

export async function saveCluster(reqt) {
   const { result } =  await doRequest('save', reqt, { blocking: true });
   return result;
}

export async function saveAccess(reqt) {
    const { result } = await doRequest('update/access', reqt, { blocking: true });
    return result;
}

export async function deleteCluster(id) {
    const { result } = await doRequest('delete', { id });
    return result;
}

export async function searchCluster(query = '') {
    const { result } = await doRequest('find', {
        query,
        limit: 12,
    }, {

        messages: false,
    });
    return result;
}

export async function searchClusterDirectly(query = '') {
    const { result } = await doRequest('available/directly', {
        query,
        limit: 12,
    }, {
        messages: false,
    });
    return result;
}

export async function searchClusterAvailable(query = '') {
    const { result } = await doRequest('available', {
        query,
        limit: 12,
    }, {
        messages: false,
    });
    return result;
}

export async function searchClustersWithOffice(reqt) {
    const { result } = await doRequest('search', reqt, { messages: false });
    return result;
}

export async function resolveCluster(id) {
    const { result } = await doRequest('get', { id });
    return result;
}
